







































import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'
import {State} from 'vuex-class'
import api from '@/api'

@Component
export default class CountryMobile extends Vue {
    @Prop({default: 0}) value!: any

    @Prop({default: false}) disabled!: boolean

    @Prop({default: null}) extendValue!: any

    @Prop({default: ''}) placeholder!: any

    @Prop({default: false}) isEmployer!: any

    @Prop({default: false}) isInterview!: any

    @Prop({default: '+65'}) defaultPrefix!: string

    @Prop({
        default() {
            return {}
        },
    }) country!: any

    get prefix() {
        let country
        if (!this.value) {
            if (this.extendValue) {
                country = this.supportCountryMap.find(item => this.extendValue.startsWith(item.areaCode))
            } else {
                return this.defaultPrefix
            }
        }
        if (this.value) {
            country = this.supportCountryMap.find(item => this.value.startsWith(item.areaCode))
        }
        return country ? country.areaCode : this.defaultPrefix
    }

    set prefix(val) {
        this.$emit('input', val + this.mobile)
    }

    get mobile() {
        if (!this.prefix || (this.value && !String(this.value).startsWith(this.prefix))) {
            return this.value
        }
        return this.value ? this.value.slice(this.prefix.length) : ''
    }

    set mobile(val) {
        val = val.replace(/[^\d]/g, '')
        this.$emit('input', this.prefix + val)
    }

    get supportCountryMap() {
        return this.isEmployer ? this.$store.state.dataMap.supportEmployerCountryMap : this.$store.state.dataMap.supportCountryMap
    }

    get currCountry() {
        if (!this.prefix) {
            return {}
        }
        return this.supportCountryMap.find(item => item.areaCode.startsWith(this.prefix)) || {}
    }

    @Watch('currCountry', {immediate: true})
    onCurrCountryChange(newVal) {
        this.$emit('update:country', newVal)
    }

    @State('userCompanyInfo') userCompanyInfo

    created() {
        this.$store.dispatch('dataMap/getSupportCountryMap')
        if (this.isEmployer) {
            this.$store.dispatch('dataMap/getEmployerSupportCountryMap')
        }
        if (this.isInterview) {
            this.$nextTick(() => {
                this.prefix = '+' + this.userCompanyInfo.countryAreaCode
            })
        }
    }

    handleCommand(command) {
        this.prefix = command
    }

    blurMobile() {
        this.$emit('blurMobile')
    }

    changeMobile(val) {
        val = val.replace(/[^\d]/g, '')
        this.$emit('changeMobile', this.prefix + val)
    }
}
